import { useState, type ComponentProps } from "react";

export function CallControl({
  label,
  hint,
  iconOnly = true,
  children,
  ...props
}: ComponentProps<"button"> & {
  label: string;
  hint?: string;
  iconOnly?: boolean;
}) {
  const [tooltipDismissed, setTooltipDismissed] = useState(false);
  return (
    <button
      {...props}
      aria-label={label}
      data-icon-only={iconOnly || undefined}
      data-tooltip-dismissed={tooltipDismissed || undefined}
      title={props.disabled ? hint || label : undefined}
      onPointerEnter={() => setTooltipDismissed(false)}
      onFocus={() => setTooltipDismissed(false)}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          setTooltipDismissed(true);
          event.stopPropagation();
        }
      }}
    >
      <span aria-hidden="true">{children}</span>
      <small
        className={iconOnly ? "call-control-tooltip" : undefined}
        aria-hidden="true"
      >
        {hint || label}
      </small>
    </button>
  );
}
